import { DataStateChangeEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs';
import { MsGridService } from './ms-grid.services';

export interface MsGridInterface {
	executeGrid(
		grid: GridComponent,
		state: DataStateChangeEventArgs,
		request?: (...arg) => void
	): void;
	getDataGrid(): Subject<DataStateChangeEventArgs>;
}

export class MsGrid implements MsGridInterface {
	private readonly gridData: Subject<DataStateChangeEventArgs> =
		new Subject<DataStateChangeEventArgs>();
	private readonly _msGridService: MsGridService;

	constructor(msGridService: MsGridService) {
		this._msGridService = msGridService;
	}

	getDataGrid(): Subject<DataStateChangeEventArgs> {
		return this.gridData;
	}

	executeGrid(
		grid: GridComponent,
		state: DataStateChangeEventArgs,
		request: (...arg) => void
	): void {
		this._msGridService.getData(request, grid, state).subscribe((x) => {
			this.getDataGrid().next(x);
		});
	}
}
